import React, { useState } from 'react';
import { Card, CardContent, Typography, TextField, Button, Box, Container, Alert } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import { tenantConfig } from '../../config/tenantConfig'; // 🚨 Added tenant config import

const ResetPasswordPage = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    // 🚨 Extract primary color and logo from tenant config
    const primaryColor = tenantConfig.primaryColor || '#6a11cb';
    const displayLogo = tenantConfig.logoUrl || tenantConfig.logo;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setError('');

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        if (!token) {
            setError('Invalid or missing reset token.');
            return;
        }

        try {
            const response = await api.post('/auth/reset-password', { token, newPassword });
            setMessage(response.data.message);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to reset password.');
        }
    };

    return (
        // 🚨 Updated background to use the tenant's exact primary color
        <Box sx={{ minHeight: 'calc(100vh - 80px)', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: primaryColor, padding: 4 }}>
            <Container maxWidth="xs">
                <Card sx={{ boxShadow: 6, borderRadius: 2 }}>
                    <CardContent sx={{ padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        
                        {/* 🚨 Added the Tenant Logo */}
                        {displayLogo && (
                            <Box component="img" src={displayLogo} alt={tenantConfig.name} sx={{ height: 60, mb: 3, objectFit: 'contain' }} />
                        )}

                        <Typography variant="h5" gutterBottom align="center" fontWeight="bold">Set a New Password</Typography>
                        
                        {message && <Alert severity="success" sx={{ mb: 2, width: '100%' }}>{message}</Alert>}
                        {error && <Alert severity="error" sx={{ mb: 2, width: '100%' }}>{error}</Alert>}
                        
                        {!message && (
                            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%' }}>
                                <TextField margin="normal" required fullWidth name="newPassword" label="New Password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                <TextField margin="normal" required fullWidth name="confirmPassword" label="Confirm New Password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                <Button 
                                    type="submit" 
                                    fullWidth 
                                    variant="contained" 
                                    sx={{ 
                                        mt: 3, 
                                        mb: 2, 
                                        py: 1.5, 
                                        backgroundColor: primaryColor, 
                                        '&:hover': { filter: 'brightness(0.9)' } 
                                    }}
                                >
                                    Reset Password
                                </Button>
                            </Box>
                        )}
                        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                            <Link to="/login" style={{ color: primaryColor, textDecoration: 'none', fontWeight: 'bold' }}>Back to Login</Link>
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default ResetPasswordPage;